module.exports = __webpack_public_path__ + "static/media/property-banner-min.95c88e77.png";